import { useEffect, useState } from "react"
import { Box, Button, Cross1Icon, Input } from "@shared/primitive-components"
import { APISearch, APISearchProps } from "./APISearch"
import * as styles from "../listWrapperStyles"

export interface SearchProps {
  onChange: (value: string) => void
  value?: string
  placeholderText?: string
  debounceDelay?: number
}

interface Props {
  apiSearch?: APISearchProps
  search?: SearchProps
  dataTestIds?: {
    field: string
    button: string
  }
  disabled?: boolean
}

const Search = ({ apiSearch, search, dataTestIds, disabled }: Props) => {
  const [hasValue, setHasValue] = useState(!!search?.value?.length)
  const [clearInput, setClearInput] = useState(false)

  useEffect(() => {
    setHasValue(!!search?.value?.length)
  }, [search?.value])

  if (apiSearch) return <APISearch {...apiSearch} disabled={disabled} />
  if (search) {
    const { value, onChange } = search
    return (
      <Box css={styles.searchContainer}>
        <Input
          dataTestId={dataTestIds?.field}
          searchButtonDataTestId={dataTestIds?.button}
          disabled={disabled}
          value={value || ``}
          onChange={onChange}
          variant="search"
          placeholder={search.placeholderText ?? `Search`}
          clearInputControls={{
            setClearInput,
            clearInput,
            setHasValue,
          }}
          debounceDelay={search.debounceDelay}
        />
        <Button
          css={() => styles.searchClearButton(hasValue)}
          variant="reset"
          disabled={disabled}
          onClick={() => {
            onChange(``)
            setClearInput(true)
            setHasValue(false)
          }}
        >
          <Cross1Icon />
        </Button>
      </Box>
    )
  }
  return null
}

Search.defaultProps = {
  apiSearch: undefined,
  search: undefined,
  dataTestIds: undefined,
  disabled: false,
}

export default Search
